/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Waiting_StatusInputs */

const en_task_field_waiting_status = /** @type {(inputs: Task_Field_Waiting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting reason`)
};

const pt_br2_task_field_waiting_status = /** @type {(inputs: Task_Field_Waiting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo da espera`)
};

/**
* | output |
* | --- |
* | "Waiting reason" |
*
* @param {Task_Field_Waiting_StatusInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_waiting_status = /** @type {((inputs?: Task_Field_Waiting_StatusInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Waiting_StatusInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_waiting_status(inputs)
	return pt_br2_task_field_waiting_status(inputs)
});